// extracted by mini-css-extract-plugin
export default {"container":"KYa5Ob"};